module.exports = __webpack_public_path__ + "static/media/img-city.2aef794c.png";